import { ActionTree } from 'vuex';
import { StartpageModule } from './types';
import { RootModule } from '../root-module';
import { crmapi } from '@/types/crm-types';
import { CrmRepository } from '@/repositories/crm-repository';
import '../../plugins/string-extensions';

export const actions: ActionTree<StartpageModule, RootModule> = {

  async loadProjects(store, activeOnly: boolean) {
    const repo = (this as any)._vm.$crmApi as CrmRepository;

    const payload = await repo.getProjectsAsync(activeOnly);

    store.commit('projectsLoaded', payload);
  },

  setSearchstring(store, searchstring: string) {
    store.commit('setSearchstring', searchstring);
  },
};
